import { render, staticRenderFns } from "./Testing.vue?vue&type=template&id=ad251952&scoped=true&"
import script from "./Testing.vue?vue&type=script&lang=js&"
export * from "./Testing.vue?vue&type=script&lang=js&"
import style0 from "./Testing.vue?vue&type=style&index=0&id=ad251952&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad251952",
  null
  
)

export default component.exports